import { Component, input, model } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { IconModule } from '@insolution/core-data-access';

@Component({
  selector: 'lib-language-selector-ui',
  imports: [TranslatePipe, NgbDropdownModule, IconModule],
  templateUrl: './language-selector-ui.html',
  styleUrl: './language-selector-ui.scss',
})
export class LanguageSelectorUI {
  public languages = input<readonly string[]>([]);
  public currentLanguage = model<string>('');

  protected setLanguage(language: string) {
    this.currentLanguage.set(language);
  }
}
